<script setup lang="ts">
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogRoot,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "reka-ui";

defineProps<{ title: string; description: string; actionLabel: string }>();
defineEmits<{ confirmed: [] }>();
defineSlots<{ default: () => any }>();
</script>
<template>
  <AlertDialogRoot>
    <AlertDialogTrigger as-child>
      <slot />
    </AlertDialogTrigger>
    <AlertDialogPortal>
      <AlertDialogOverlay class="tw-fixed tw-inset-0 tw-z-[1000000] tw-h-full tw-w-full tw-bg-black/30" />
      <AlertDialogContent class="tw-fixed tw-inset-0 tw-z-[1000000] tw-flex tw-items-center tw-justify-center">
        <div class="tw-w-full tw-max-w-sm tw-rounded-lg tw-border tw-bg-white tw-px-5 tw-py-5 tw-shadow-lg">
          <AlertDialogTitle class="tw-text-balance tw-text-center tw-text-2xl tw-font-bold">
            {{ title }}
          </AlertDialogTitle>
          <AlertDialogDescription class="tw-mt-2 tw-text-center tw-text-sm tw-text-gray-700">
            {{ description }}
          </AlertDialogDescription>
          <div class="tw-mt-4 tw-flex tw-items-center tw-justify-end tw-gap-2">
            <AlertDialogCancel class="tw-btn-md-gray tw-min-w-20">Cancel</AlertDialogCancel>
            <AlertDialogAction class="tw-btn-md-red tw-min-w-20" @click="$emit('confirmed')">
              {{ actionLabel }}
            </AlertDialogAction>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialogPortal>
  </AlertDialogRoot>
</template>
